import React from 'react';
import { CurrentPrices } from './CurrentPrices';

export default function AdminCurrentPrices() {
  return (
    <div className="space-y-5" data-testid="admin-current-prices-page">
      <header>
        <h1 className="font-serif text-[30px] leading-tight">Precios vigentes</h1>
        <p className="text-[12.5px] text-[#5a5a5a] mt-1">Precio oficial vigente por estación propia · último push autorizado por Pricing o precio oficial.</p>
      </header>
      <CurrentPrices/>
    </div>
  );
}
